<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listcompanies" class="blue-grey-text text-darken-4 strong">Security Master: Companies</router-link>
        >
        <span>View Crypto</span>
      </section>
    </article>
    <h4>View Crypto</h4>
    <table class="container">
      <tbody>
        <tr>
          <th>Recommendations</th>
          <td>
            <router-link :to="`/tickeradmin/viewrecommendations?instrument_id=${instrument.id}`">
              See Recommendations
            </router-link>
          </td>
        </tr>
        <tr>
          <th>Instrument ID</th>
          <td>{{ instrument.id }}</td>
        </tr>
        <tr>
          <th>Asset Class </th>
          <td>{{ instrument.asset_class}}</td>
        </tr>
        <tr>
          <th>Symbol</th>
          <td>{{ instrument.symbol }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ instrument.name }}</td>
        </tr>
        <tr>
          <th>Is Active</th>
          <td>
            <i class="fas fa-times-circle red-text" v-if="instrument.inactive_date" />
            <i class="fas fa-check-circle green-text" v-else />
          </td>
        </tr>
        <tr v-if="instrument.inactive_date">
          <th>Inactive Date</th>
          <td>{{ instrument.inactive_date }}</td>
        </tr>
        <tr>
          <th>Platform</th>
          <td>{{ instrument.platform }}</td>
        </tr>
        <tr>
          <th>Platform Contract Address</th>
          <td>{{ instrument.platform_contract_address }}</td>
        </tr>
        <tr>
          <th>Inception Date</th>
          <td>{{ instrument.inception_date }}</td>
        </tr>
        <tr>
          <th>Inactive Date</th>
          <td>{{ instrument.inactive_date }}</td>
        </tr>
        <tr>
          <th>Project Url</th>
          <td>{{ instrument.project_url }}</td>
        </tr>
        <tr>
          <th>Logo Url</th>
          <td>{{ instrument.logo_url }}</td>
        </tr>
        <tr>
          <th>Whitepaper Url</th>
          <td>{{ instrument.whitepaper_url }}</td>
        </tr>
      </tbody>
    </table>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TickerAdminViewCrypto',
  data() {
    return {
      instrument: { exchange: {}, security_class: {} },
    };
  },
  computed: {
    instrumentId() {
      return this.$route.query.instrument_id || 0;
    },
  },
  methods: {
    async fetchCrypto() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/crypto/${this.instrumentId}/`);
      this.instrument = data;
    },
  },
  mounted() {
    this.fetchCrypto();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

nav {
  padding-left: 20px;
}

.usm-edit-instrument-aside {
  position: absolute;
  top: 30px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}
</style>
